





















import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import Alert from '@/components/Shared/Alert.vue';
import ReportingPeriods from '@/components/ReportingPeriods/ReportingPeriods.vue';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import PageNames from '@/router/PageNames';

@Component({
	name: 'ReportingPeriodSettings',
	components: { Alert, ReportingPeriods }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getReportingPeriods();
	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

	get loading() {
		return AgencySettingsModule.loadingReportingPeriods;
	}
}
